const scanDataConfig = {
  serviceName: '/scan-data-service',
  path: 'api/smartengines/recognize',
};

export default scanDataConfig;
